import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppoggioService } from './appoggio.service';
declare var Stripe: any;

@Injectable({
  providedIn: 'root'
})
export class StripeService {

  private stripeSource = new BehaviorSubject<any>(null);
  stripe$ = this.stripeSource.asObservable();

  loading = false;

  risultatoTransazione: any;

  infoStripe: any;

  constructor(
    private http: HttpClient,
    private appoggioService: AppoggioService
  ) {

  }


  charge(datiPagamento): Observable<any> {

    datiPagamento.tipo = 'stripe';
    datiPagamento.tipo2 = 'initPagamentoSito';

    return this.http.post(
      environment.apiUrl + 'public/',
      JSON.stringify(datiPagamento))
      .pipe(map(response => {
        return response;
      }));
  }

  getInfoStripe() {
    return this.infoStripe
  }

  getStripe() {
    return this.stripe$;
  }

  setInfoStripe(valori) {
    this.infoStripe = valori;
    if (this.infoStripe && this.infoStripe.abilitatoAccount) {
      this.stripeSource.next(Stripe(this.infoStripe.api_key));
    } else {
      this.stripeSource.next(Stripe(environment.stripePublishable));
    }
  }
}
